module.exports = __webpack_public_path__ + "static/media/partner12.7b9d4016.jpg";